var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_192_59607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 64,
    height: 64
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_192_59607)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#004E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9148 30.1248H39.7676C46.2017 30.1248 51.4753 35.3899 51.4753 41.8325V50.7584H39.6225C33.1884 50.7584 27.9148 45.4933 27.9148 39.0507V30.1248Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9142 56.5355H66.3403C64.6934 56.5355 63.3365 55.1872 63.3365 53.5317V47.456H70.9142V47.3792C70.9142 43.2491 67.535 39.8784 63.4133 39.8784H57.3376V56.4587H30.1675V64.0363H33.1712C33.1712 66.5109 35.1936 68.5419 37.6768 68.5419C40.16 68.5419 42.1824 66.5195 42.1824 64.0363H43.6843C43.6843 66.5109 45.7067 68.5419 48.1899 68.5419C50.6731 68.5419 52.6955 66.5195 52.6955 64.0363H58.6944C58.6944 66.5109 60.7168 68.5419 63.2 68.5419C65.6832 68.5419 67.7056 66.5195 67.7056 64.0363H70.7094V56.5355H70.9312H70.9142Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckLogo);
export default __webpack_public_path__ + "static/media/TruckLogo.ddfeb58204f78d3a2245b43abfe6813e.svg";
export { ForwardRef as ReactComponent };